import './LoadingIndicator.css';

export default function LoadingIndicator({
    color = 'black',
}: {
    color?: string;
}) {
    return (
        <div className="Loading-indicator">
            <div className={`lds-ellipsis`}>
                <div className="bg-[#000000] dark:bg-[#FFFFFF]"></div>
                <div className="bg-[#000000] dark:bg-[#FFFFFF]"></div>
                <div className="bg-[#000000] dark:bg-[#FFFFFF]"></div>
                <div className="bg-[#000000] dark:bg-[#FFFFFF]"></div>
            </div>
        </div>
    );
}
